import React from 'react';
import { Gift, BookOpen, Video, FileText, ChefHat, Stethoscope } from 'lucide-react';
export function BonusBundle() {
  const bonuses = [{
    icon: <ChefHat className="w-8 h-8 text-terracotta" data-id="element-1" />,
    title: 'Recetario Express 15 Minutos',
    value: '$29',
    desc: '30 recetas balanceadas que puedes preparar más rápido que ir a comprar croquetas.'
  }, {
    icon: <Stethoscope className="w-8 h-8 text-terracotta" data-id="element-2" />,
    title: 'Guía de Suplementos Naturales',
    value: '$19',
    desc: 'Qué vitaminas y minerales necesita realmente tu mascota según su edad y raza.'
  }, {
    icon: <Video className="w-8 h-8 text-terracotta" data-id="element-3" />,
    title: 'Masterclass: Lectura de Etiquetas',
    value: '$49',
    desc: 'Aprende a descifrar los ingredientes engañosos en la comida comercial.'
  }, {
    icon: <FileText className="w-8 h-8 text-terracotta" data-id="element-4" />,
    title: 'Planificador de Transición',
    value: '$15',
    desc: 'Plantillas imprimibles para llevar el control exacto de los primeros 14 días.'
  }, {
    icon: <BookOpen className="w-8 h-8 text-terracotta" data-id="element-5" />,
    title: 'Diccionario de Alimentos Tóxicos',
    value: '$25',
    desc: 'La lista definitiva de lo que NUNCA debe comer tu mascota (algunos te sorprenderán).'
  }];
  return <section className="py-24 bg-sage-dark text-white overflow-hidden relative" data-id="element-6">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2" data-id="element-7"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-terracotta/10 rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2" data-id="element-8"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-9">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-10">
          <div className="inline-flex items-center space-x-2 px-4 py-2 rounded-full bg-white/10 text-white text-sm font-medium mb-6" data-id="element-11">
            <Gift className="w-4 h-4" data-id="element-12" />
            <span data-id="element-13">Bonos Exclusivos</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6" data-id="element-14">
            Llévate todo este arsenal de salud{' '}
            <span className="text-terracotta-light italic" data-id="element-15">GRATIS</span> hoy
          </h2>
          <p className="text-lg text-white/80" data-id="element-16">
            Al adquirir "Más Años Juntos" hoy, también recibes estos 5 bonos
            premium valorados en $137 USD sin costo adicional.
          </p>
        </div>

        {/* Horizontal Scroll Container for Cards */}
        <div className="flex overflow-x-auto pb-8 -mx-4 px-4 sm:mx-0 sm:px-0 gap-6 snap-x snap-mandatory hide-scrollbar" data-id="element-17">
          {bonuses.map((bonus, i) => <div key={i} className="min-w-[280px] md:min-w-[320px] flex-none snap-center bg-white/10 backdrop-blur-md rounded-3xl p-8 border border-white/20 hover:bg-white/15 transition-colors" data-id="element-18">
              <div className="bg-white rounded-2xl w-16 h-16 flex items-center justify-center mb-6 shadow-lg" data-id="element-19">
                {bonus.icon}
              </div>
              <div className="text-terracotta-light font-bold text-sm mb-2 uppercase tracking-wider" data-id="element-20">
                Bono #{i + 1} • Valor {bonus.value}
              </div>
              <h3 className="text-xl font-bold mb-3 leading-tight" data-id="element-21">
                {bonus.title}
              </h3>
              <p className="text-white/70 text-sm leading-relaxed" data-id="element-22">
                {bonus.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}